export const pxToRemFromBase = (base: number) => (px: number) => `${px / base}rem`;

export const rem = pxToRemFromBase(16);
